import React from 'react';
import { cn } from '@bem-react/classname';
import './Taro.style.scss';

import { PdfViewer } from '@components/PdfViewer';
const CnTaro = cn('taro');

const Taro = () => {
  return (
    <div className={CnTaro()}>
      <PdfViewer file={'taro.pdf'} />
    </div>
  );
};

export default Taro;
